(function () {
  var modalWrap = document.querySelector('[data-upsell-modal]');
  if (!modalWrap) return;

  var DISCOUNT_RATE = 0.10; // must match the Automatic Discount configured in Shopify admin
  var formPrefix = modalWrap.dataset.formIdPrefix;
  var drawersEnabled = modalWrap.dataset.drawersEnabled === 'true';
  var cardsEl = modalWrap.querySelector('[data-upsell-cards]');
  var checkoutBtn = modalWrap.querySelector('[data-proceed]');

  // The whole cart-add payload for the main product, not just its id.
  //
  // This used to hold { variantId, quantity } and the payload was rebuilt
  // from those two fields alone, which silently threw away everything else
  // the form carried — line item properties above all. Intercepting a form
  // submit means taking over the ENTIRE job of that submit, and this was
  // doing about a fifth of it.
  var pendingMain = null;   // { id, quantity, properties?, selling_plan? }
  var cardState = [];       // [{ variantId, selected }]

  function closeModal() {
    modalWrap.hidden = true;
    cardsEl.innerHTML = '';
    cardState = [];
  }
  modalWrap.querySelectorAll('[data-upsell-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      closeModal();
      if (pendingMain) submitAndGo([pendingMain], '/cart');
    });
  });

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function fetchProductJSON(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function findDrawerVariant(drawersProduct, size, finish) {
    if (!drawersProduct) return null;
    return drawersProduct.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3].filter(Boolean);
      return opts.includes(size) && opts.includes(finish);
    }) || null;
  }

  function buildCard(entry, large) {
    var discounted = Math.round(entry.price * (1 - DISCOUNT_RATE));
    var wrap = document.createElement('div');
    wrap.className = 'upsell-card' + (large ? ' upsell-card--large' : '');
    wrap.innerHTML =
      (entry.image ? '<img class="upsell-card__img" src="' + entry.image + '" alt="">' : '') +
      '<div class="upsell-card__body">' +
        '<p class="upsell-card__name">' + entry.name + '</p>' +
        '<p class="upsell-card__message">' + entry.message + '</p>' +
        '<p class="upsell-card__price"><s>' + money(entry.price) + '</s><b>' + money(discounted) + '</b></p>' +
      '</div>' +
      '<button type="button" class="upsell-card__toggle">Add</button>';

    var toggleBtn = wrap.querySelector('.upsell-card__toggle');
    toggleBtn.addEventListener('click', function () {
      entry.selected = !entry.selected;
      wrap.classList.toggle('is-added', entry.selected);
      toggleBtn.textContent = entry.selected ? 'Added' : 'Add';
    });

    return wrap;
  }

  function buildLinkCard(name, message, url) {
    var wrap = document.createElement('a');
    wrap.href = url;
    wrap.className = 'upsell-card upsell-card--link';
    wrap.innerHTML =
      '<div class="upsell-card__body">' +
        '<p class="upsell-card__name">' + name + '</p>' +
        '<p class="upsell-card__message">' + message + '</p>' +
      '</div>' +
      '<span class="upsell-card__toggle">Browse</span>';
    return wrap;
  }

  function submitAndGo(items, destination) {
    // The response was being ignored and the redirect fired regardless, so a
    // refused add — sold out, a required property missing, an invalid line —
    // sent the customer to an empty cart with no idea anything had gone
    // wrong. Shopify returns the reason; show it and stay put.
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return null; }).then(function (body) {
          throw new Error((body && (body.description || body.message)) || 'Could not add to cart.');
        });
      }
      window.location.href = destination;
    }).catch(function (err) {
      showError(err && err.message ? err.message : 'Could not add to cart. Please try again.');
    });
  }

  function showError(message) {
    var box = modalWrap.querySelector('[data-upsell-error]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-upsell-error', '');
      box.setAttribute('role', 'alert');
      box.style.cssText = 'color:#b42318;background:#fef3f2;border:1px solid #fecdca;'
        + 'border-radius:8px;padding:10px 12px;margin:12px 0 0;font-size:14px;';
      var panel = modalWrap.querySelector('.upsell-modal__panel');
      if (panel) panel.appendChild(box); else return;
    }
    box.textContent = message;
    modalWrap.hidden = false;
    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.textContent = 'Proceed to Checkout';
    }
  }

  checkoutBtn.addEventListener('click', function () {
    if (!pendingMain) return;
    var items = [pendingMain];
    cardState.forEach(function (c) {
      if (c.selected) items.push({ id: c.variantId, quantity: 1 });
    });
    checkoutBtn.disabled = true;
    checkoutBtn.textContent = 'Adding...';
    submitAndGo(items, '/checkout');
  });

  /**
   * Everything the native submit would have sent.
   *
   * Built from the form itself rather than hand-assembled, so line item
   * properties, selling plans and any hidden input the theme or an app added
   * all survive. FormData also skips disabled and unchecked fields, which is
   * exactly what a real submit does.
   */
  function itemFromForm(form) {
    var fd = new FormData(form);
    var rawId = fd.get('id');
    if (!rawId) return null;

    var item = {
      id: Number(rawId) || rawId,
      quantity: parseInt(fd.get('quantity'), 10) || 1
    };

    var properties = {};
    var hasProps = false;
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m) { properties[m[1]] = value; hasProps = true; }
    });
    if (hasProps) item.properties = properties;

    var sellingPlan = fd.get('selling_plan');
    if (sellingPlan) item.selling_plan = Number(sellingPlan) || sellingPlan;

    return item;
  }

  /**
   * The variant the customer actually chose.
   *
   * Read from the form's own id field, which the theme keeps in sync on every
   * option change, then looked up in the full variants array.
   *
   * It used to read [data-current-variant-json], which Liquid renders ONCE
   * with the variant the page loaded on and which nothing ever rewrites —
   * theme.js only parses it at init. So whatever the customer selected, this
   * returned the default, and the cart showed options they had not picked.
   * That is the bug: on a furniture set with size, frame colour and mattress
   * options, every order through this modal got the page-load variant.
   */
  function getSelectedVariant(form) {
    var section = form.closest('[data-product-id]');
    if (!section) return null;

    var fd = new FormData(form);
    var id = Number(fd.get('id'));

    var all = section.querySelector('[data-variant-json]');
    if (all && id) {
      try {
        var variants = JSON.parse(all.textContent);
        var found = variants.find(function (v) { return v.id === id; });
        if (found) return found;
      } catch (e) {}
    }

    // Last resort. Stale by construction, but better than refusing to open.
    var textarea = section.querySelector('[data-current-variant-json]');
    if (textarea) {
      try { return JSON.parse(textarea.textContent); } catch (e) {}
    }
    return null;
  }

  async function openModalForForm(form) {
    var variant = getSelectedVariant(form);
    if (!variant) return false;

    // If the form cannot be read, fall through to the native submit rather
    // than adding a guess. A wrong line in the cart is worse than no modal.
    pendingMain = itemFromForm(form);
    if (!pendingMain) return false;

    var size = (variant.option1 === 'Full' || variant.option1 === 'Queen') ? variant.option1 : null;
    var frameColor = [variant.option1, variant.option2, variant.option3].find(function (v) {
      return v && v !== size && v !== 'No Mattress';
    });

    cardsEl.innerHTML = '';
    cardState = [];
    if (drawersEnabled && size) {
var INSITU_DRAWER_IMAGES = {
        'Mission Arm': {
          'Espresso': 'https://cdn.shopify.com/s/files/1/0984/8678/0221/files/monterey-frame-queen-espresso-finish-frame-storage-drawers.jpeg',
          'Butternut': 'https://cdn.shopify.com/s/files/1/0984/8678/0221/files/0d5a6575-monterey-frame-butternut-finish-linen-cocoa-mattress-storage-drawers.jpg'
        },
        'Lexington': {
          'Weathered White': 'https://cdn.shopify.com/s/files/1/0984/8678/0221/files/0b354e24-lexington-frame-weathered-white-finish-takara-rain-mattress-storage-drawers-without-shadow.jpg'
        }
      };

      var drawersProduct = await fetchProductJSON('futon-storage-drawers');
      var match = findDrawerVariant(drawersProduct, size, frameColor);
      if (match) {
        var family = modalWrap.dataset.productFamily;
        var insitu = (INSITU_DRAWER_IMAGES[family] || {})[frameColor];
        var drawerImage = insitu
          || (match.featured_image && match.featured_image.src)
          || drawersProduct.featured_image
          || null;

        var drawerEntry = {
          variantId: match.id,
          name: 'Storage Drawers — ' + frameColor,
          message: 'Add extra storage in a matching wood finish.',
          price: match.price,
          image: drawerImage,
          selected: false
        };
        cardState.push(drawerEntry);
        cardsEl.appendChild(buildCard(drawerEntry, true));
      }
      // no matching finish for this color → card simply omitted
    }

    var gripPadProduct = await fetchProductJSON('grip-pad-for-futon-frame');
    if (gripPadProduct && gripPadProduct.variants.length) {
      var gp = gripPadProduct.variants[0];
      var gpEntry = {
        variantId: gp.id,
        name: 'Non-Slip Grip Pad',
        message: 'Prevents the mattress from slipping, custom-cut to your size.',
        price: gp.price,
        image: gripPadProduct.featured_image || 'https://cdn.shopify.com/s/files/1/0984/8678/0221/files/gripper-pad-futon-frame.png',
        selected: false
      };
      cardState.push(gpEntry);
      cardsEl.appendChild(buildCard(gpEntry));
    }

    if (cardState.length === 0) return false; // nothing to offer

    checkoutBtn.disabled = false;
    checkoutBtn.textContent = 'Proceed to Checkout';
    modalWrap.hidden = false;
    return true;
  }

  function bindInterception() {
    var forms = document.querySelectorAll('form[id^="' + formPrefix + '"]');
    forms.forEach(function (form) {
      var triggers = form.querySelectorAll('[type="submit"], button[name="add"]');
      triggers.forEach(function (btn) {
        function handler(e) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();

          openModalForForm(form).then(function (opened) {
            if (opened === false) {
              btn.removeEventListener('click', handler, true);
              btn.click();
              btn.addEventListener('click', handler, true);
            }
          });
        }
        btn.addEventListener('click', handler, true);
      });
    });
  }

  bindInterception();
})();